import * as React from 'react';

import { Button } from '@cian/ui-kit/button';

export interface IShowPhonesButtonProps {
  label: string;
  onClick(): void;
}

export const ShowPhonesButton: React.VFC<IShowPhonesButtonProps> = ({ label, onClick }) => {
  return (
    <Button fullWidth size="L" onClick={onClick} data-mark="CallToAction">
      {label}
    </Button>
  );
};
